import { Row } from "antd";
import icon from "../../images/warn-icon.svg";

type PercentageWarningProps = {
  value: number;
};

export const PercentageWarning = ({ value }: PercentageWarningProps) => {
  return (
    <Row className="w-100 align-center warn__container px-4 py-2 mb-4">
      <img alt="restricted" src={icon} />
      <p className="ml-2 my-0">
        Total percentage allocation is {value}% of 100%. Adjust this to unblock
        payments.
      </p>
    </Row>
  );
};
